export default function formatPhoneNumber(str) {
  // Remove any non-numeric characters from the string, and limit its length.
  str = str.replace(/\D/g, '').slice(0, 10)

  // Depending on length, format the string as:
  if (str.length > 6) {
    // (xxx) xxx-xxx
    return `(${str.slice(0, 3)}) ${str.slice(3, 6)}-${str.slice(6)}`
  } else if (str.length > 3) {
    // (xxx) xxx
    return `(${str.slice(0, 3)}) ${str.slice(3)}`
  }

  // xxx
  return str
}



// WEBPACK FOOTER //
// ./src/utils/formatPhoneNumber.js